import PoweredByLogo from "./PoweredByLogo"

export default PoweredByLogo
